import { useState, useEffect } from 'react';
import {
    getUserPermissions,
    hasPermission,
    canCreate,
    canRead,
    canUpdate,
    canDelete,
    canManage,
    isAdmin,
    getUserRole,
    PermissionSubject,
    PermissionAction,
    type Permission
} from '@/utils/permissions';

export const usePermissions = () => {
    const [permissions, setPermissions] = useState<Permission[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const loadPermissions = () => {
            try {
                const userPermissions = getUserPermissions();
                setPermissions(userPermissions);
                setIsLoading(false);
            } catch (error) {
                console.error('Error loading permissions:', error);
                setIsLoading(false);
            }
        };

        loadPermissions();

        // Listen for storage changes (when permissions are updated)
        const handleStorageChange = (e: StorageEvent) => {
            if (e.key === 'permission') {
                loadPermissions();
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    return {
        permissions,
        isLoading,
        hasPermission: (subject: PermissionSubject | string, action: PermissionAction | string) => hasPermission(subject, action),
        canCreate: (subject: PermissionSubject | string) => canCreate(subject),
        canRead: (subject: PermissionSubject | string) => canRead(subject),
        canUpdate: (subject: PermissionSubject | string) => canUpdate(subject),
        canDelete: (subject: PermissionSubject | string) => canDelete(subject),
        canManage: (subject: PermissionSubject | string) => canManage(subject),
        isAdmin: () => isAdmin(),
        getUserRole: () => getUserRole(),
    };
};
